import React from 'react'
import { Container } from 'Common'
import dev from 'Static/illustrations/social.svg'
import { Wrapper, Links, Details, Thumbnail, SocialWrapper } from './styles'
import social from './social.json'

export const Social = () => (
	<Wrapper id="social">
		<SocialWrapper as={Container}>
			<Thumbnail>
				<img src={dev} alt="I’m a Frontend Developer!" />
			</Thumbnail>
			<Details>
				<h1>Let's get social</h1>
				<p>
					Follow my online fan page on Instagram and profiles on GitHub and
					Linkedin.
				</p>
				<Links>
					{social.map(({ id, name, link, icon }) => (
						<a
							key={id}
							href={link}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={`follow me on ${icon}`}
						>
							<img width="50" src={icon} alt={name} />
						</a>
					))}
				</Links>
			</Details>
		</SocialWrapper>
	</Wrapper>
)
